import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../config";

export const sendMessage = createAsyncThunk(
  "message/send",
  async (messageData) => {
    const response = await fetch(`${config.apiBaseUrl}/send-message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(messageData),
    });

    if (!response.ok) {
      throw new Error("Message could not be sent");
    }

    const result = await response.json();
    return result;
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default contactSlice.reducer;
